/**
 * WordPress dependencies
 */
import { store, getContext, getServerState } from '@wordpress/interactivity';

(function($){

	// Function to dynamically load a JavaScript file
	function loadScript(url, callback) {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    // Function to dynamically load a CSS file
    function loadStyle(url) {
        const link = document.createElement('link');
        link.href = url;
        link.type = 'text/css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }

	// Load js-cookie script
	loadScript(gtFseCtvVars.pluginUrl + '/lib/jscookies/js.cookies.min.js');

	 // Load Moment.js first
	 loadScript(gtFseCtvVars.pluginUrl + '/lib/caleran/vendor/moment.min.js', function () {
        // After Moment.js is loaded, load Caleran script
        loadScript(gtFseCtvVars.pluginUrl + '/lib/caleran/js/caleran.min.js');
    });

    // Load Caleran CSS
    loadStyle(gtFseCtvVars.pluginUrl + '/lib/caleran/css/caleran.min.css');



	//Display search hebergement
	$(document).on('click', '.gt-fse-form-resa-field-submit', function () {
		let params = {
			dateStart: $('.gt-caleran-debut').val(),
			dateEnd: $('.gt-caleran-fin').val(),
		};
		window.dispatchEvent(new CustomEvent('ctv-widget.open-search', { detail: params }));    
	})

	
    function inTwoHours(){
        let time = new Date();
        time.setHours( time.getHours() + 2 );
        return time;
    }

	$(window).on('load', function(){

		const gtOptions = store('gt/options');

		var startDate, endDate, startInstance, endInstance;

		var fillInputs = function () {
			startInstance.$elem.val(startDate ? startDate.locale(startInstance.config.format).format(startInstance.config.format) : "");
			endInstance.$elem.val(endDate ? endDate.locale(endInstance.config.format).format(endInstance.config.format) : "");
		};

		if(gtOptions && gtOptions.state){
			var opening = moment();
			var closing = moment();
            if(gtOptions.state.opening_date){
                opening = moment(gtOptions.state.opening_date).format('DD/MM/YYYY');
				var startEnd = moment(opening).add(7,'days');
			}
            if(gtOptions.state.closing_date){
				closing = moment(gtOptions.state.closing_date).format('DD/MM/YYYY');
            }
        }
		
		if(!Cookies.get('gt-arrival')){
            var gtArrival = moment() > opening ? moment() : opening;			
        }
        else{
            var gtArrival = getServerState();
        }

        if(!Cookies.get('gt-departure')){
            var gtDeparture = moment(opening).add(7,'days');
        }
        else{
            var gtDeparture = getServerState();
        }

		let language = 'fr';
		if (jQuery('html').attr('lang')) {
			language = jQuery('html').attr('lang').slice(0, 2);
		}

		// Initialisation des calednriers
		$('.gt-caleran-debut').caleran({
			startOnMonday: true,
			showButtons: false,
			autoCloseOnSelect: true,
			locale: language,
			format: "DD/MM/YYYY",
			calendarCount: 1,
			minDate:opening,
			maxDate:closing,
			showHeader: false,
			showFooter: false,
			hideOutOfRange: true,
			startDate: gtArrival,
			endDate: gtDeparture,
			enableKeyboard: false,	
			
			oninit: function (instance) {
				startInstance = instance;
				if (!instance.config.startEmpty && instance.config.startDate) {
					instance.$elem.val(instance.config.startDate.locale(instance.config.format).format(instance.config.format));
					startDate = instance.config.startDate.clone();
				}
			},

			onbeforeshow: function (instance) {
				if (startDate) {
					startInstance.config.startDate = startDate;
					endInstance.config.startDate = startDate;
				}
				if (endDate) {
					startInstance.config.endDate = endDate.clone();
					endInstance.config.endDate = endDate.clone();
				}
				fillInputs();
				instance.updateHeader();
				instance.reDrawCells();
			},
			
			onafterselect: function(caleran, startDate) {

				gtArrival = startDate.format('DD/MM/YYYY');
				if(gtArrival >= $('.gt-caleran-fin').val()){
					$('.gt-caleran-fin').val(startDate.add(7,'days').format('DD/MM/YYYY'))
				}
			
			},
			onfirstselect: function (instance, start) {
				startDate = start.clone();
				startInstance.globals.startSelected = false;
				startInstance.hideDropdown();
				endInstance.showDropdown();
				endInstance.config.minDate = startDate.clone();
				endInstance.config.startDate = startDate.clone();
				endInstance.config.endDate = null;
				endInstance.globals.startSelected = true;
				endInstance.globals.endSelected = false;
				endInstance.globals.firstValueSelected = true;
				endInstance.setDisplayDate(start);
				if (endDate && startDate.isAfter(endDate)) {
					endInstance.globals.endDate = endDate.clone();
				}
				endInstance.updateHeader();
				endInstance.reDrawCells();
				fillInputs();
			}
		});
		$('.gt-caleran-fin').caleran({

			startOnMonday: true,
			showButtons: false,
			autoCloseOnSelect: true,
			locale: language,
			format: "DD/MM/YYYY",
			calendarCount: 1,
			showHeader: false,
			showFooter: false,
			hideOutOfRange: true,
			minDate: opening,
			maxDate: closing,
			startDate: startEnd,
			//endDate: gtDeparture,
			//startDate: gtDeparture,  
			enableKeyboard: false,
			autoCloseOnSelect: true,		

			oninit: function (instance) {

				endInstance = instance;
				if (!instance.config.startEmpty && instance.config.endDate) {
					instance.$elem.val(instance.config.endDate.locale(instance.config.format).format(instance.config.format));
					endDate = instance.config.endDate.clone();
				}

			},

			onbeforeshow: function (instance) {
				if (startDate) {
					startInstance.config.startDate = startDate;
					endInstance.config.startDate = startDate;
				}
				if (endDate) {
					startInstance.config.endDate = endDate.clone();
					endInstance.config.endDate = endDate.clone();
				}

				fillInputs();
				instance.updateHeader();
				instance.reDrawCells();
			},

			onafterselect: function (instance, start, end) {
				startDate = start.clone();
				endDate = end.clone();
				endInstance.hideDropdown();
				startInstance.config.endDate = endDate.clone();
				startInstance.globals.firstValueSelected = true;
				fillInputs();
				endInstance.globals.startSelected = true;
				endInstance.globals.endSelected = false;
			}
		});
	});

})(jQuery);

const { state } = store('gt/gt-fse-form-resa', {
	state: {
		hovered: false,	
	},

	actions: {

		onMouseEnter(event){
			state.hovered = true;
		},

		onMouseLeave(event){
			state.hovered = false;
		},

		toggle: () => {
			const context = getContext();
			context.isHover = ! context.isHover;
			console.log("coucou");
			if (context.isHover) {
				
			}

		},
		toggleOpen() {
			const context = getContext();
			context.isOpen = ! context.isOpen;
		},
		toggleTheme() {
			state.isDark = ! state.isDark;
		},
		init(){
			console.log(state.promotions);
		},
		
	},
	callbacks: {
		// logIsOpen: () => {
		// 	const { isOpen } = getContext();
		// 	// Log the value of `isOpen` each time it changes.
		// },
	},
});

